"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllotmentTariffCell = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../../../utils/classFunctions");
const tariffGroupMapper_1 = require("../../../../TariffsTable/tariffGroupMapper");
require("./index.scss");
const className = 'allotment-tariff-cell';
const AllotmentTariffCell = (props) => {
    const { tariff } = props;
    const { locale } = (0, react_intl_1.useIntl)();
    const code = (0, tariffGroupMapper_1.mapTariffGroupIdToCode)(tariff === null || tariff === void 0 ? void 0 : tariff.id);
    const classNames = (0, classFunctions_1.getClassNames)(className, [
        code,
    ]);
    return (react_1.default.createElement("div", { className: classNames }, tariff === null || tariff === void 0 ? void 0 : tariff.name[locale]));
};
exports.AllotmentTariffCell = AllotmentTariffCell;
//# sourceMappingURL=index.js.map